import { Soup } from "lucide-react";

export const Footer = ({ party }) => (
  <footer className="relative bg-[#171310] px-6 md:px-16 lg:px-24 py-14" data-testid="footer">
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
      <div className="flex items-center gap-3">
        <Soup className="text-ember" size={22} />
        <span className="font-display text-lg text-[#F5EFE6]">{party?.title || "Soup Party"}</span>
      </div>
      <p className="font-accent text-2xl text-[#D9BC93] -rotate-1">bring a ladle, leave with memories</p>
    </div>
  </footer>
);
